import { useGetFlightInfoQuery } from '@/src/api/rtkQuery/itineraryApi'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'

const useFlightInfoApi = ({ skip = false }: { skip?: boolean }) => {
    const itineraryId = useGetItineraryId()
    useGetFlightInfoQuery(
        {
            itineraryId
        },
        {
            skip
        }
    )
}

export default useFlightInfoApi
